/** Compact funding ceiling for the private tombstone "Funding goal" figure. */
export const formatOfferingAmount = (amount: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    notation: 'compact',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
